import { PerformanceDtosReviewProcessCreateFromTemplateTemplateTypeEnum } from 'generated/resources/graphql'

export const isValidTemplateType = (
  value?: string
): value is PerformanceDtosReviewProcessCreateFromTemplateTemplateTypeEnum => {
  return value === 'custom' || value === 'predefined'
}
